
import { defineComponent, PropType, reactive, watch } from 'vue'

// UI
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

// Types
import { AdditionalServicesI } from '@/core/types/additional_services.types'
import { AdditionalByIdT } from '@/core/types/billing.types'

export default defineComponent({
    components: {
        TheButton,
        Checkbox,
        Loader,
    },
    props: {
        isSender: {
            type: Boolean,
            default: true,
        },
        isReceiver: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<AdditionalServicesI>,
            required: true,
        },
        isSetted: {
            type: Boolean,
            default: false,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        opened: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        additionalServices: {
            type: Array as PropType<AdditionalByIdT[]>,
            default: () => [],
        },
    },
    emits: ['submit', 'update'],
    setup(props, { emit }) {
        const state: AdditionalServicesI = reactive({
            hasCar: false,
            hasSoftPackage: false,
            hasManipulator: false,
            hasCrane: false,
            hasHydraulicTrolley: false,
            hasGrid: false,
            hasLoader: false,
            hasPallet: false,
        })

        const emitSubmit = () => {
            emit('submit', { ...state })
        }

        const emitUpdate = () => {
            emit('update')
        }

        watch(
            () => props.isUpdate,
            (is_update) => {
                if (is_update) {
                    state.hasCar = props.initialValue.hasCar
                    state.hasSoftPackage = props.initialValue.hasSoftPackage
                    state.hasManipulator = props.initialValue.hasManipulator
                    state.hasCrane = props.initialValue.hasCrane
                    state.hasHydraulicTrolley = props.initialValue.hasHydraulicTrolley
                    state.hasGrid = props.initialValue.hasGrid
                    state.hasLoader = props.initialValue.hasLoader
                    state.hasPallet = props.initialValue.hasPallet
                } else {
                    state.hasCar = false
                    state.hasSoftPackage = false
                    state.hasManipulator = false
                    state.hasCrane = false
                    state.hasHydraulicTrolley = false
                    state.hasGrid = false
                    state.hasLoader = false
                    state.hasPallet = false
                }
            }
        )

        const getValue = (service_name: string, key: keyof AdditionalByIdT) => {
            const service = props.additionalServices.find((s) => s.name === service_name)
            if (!service) return '-'
            return service[key]
        }

        return {
            state,
            //
            emitSubmit,
            emitUpdate,
            //
            getValue,
        }
    },
})
